const ROWS = [
  ["Institution-centric", "Network-level"],
  ["Static one-time training", "Continuous learning engine"],
  ["Siloed content & faculty", "Shared, reusable assets"],
  ["Reactive programme design", "Predictive, demand-driven"],
  ["Manual data entry", "Silent capture at every touchpoint"],
  ["Linear, episodic delivery", "Looped, self-improving system"],
];

export default function ParadigmShift() {
  return (
    <section id="shift" data-testid="paradigm-shift-section" className="bg-cream py-28 md:py-36">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-12">
          <div>
            <div className="font-mono-data text-xs tracking-[0.3em] uppercase text-terracotta mb-4">03 · Paradigm Shift</div>
            <h2 className="font-serif-display text-4xl lg:text-5xl leading-[1.05] max-w-3xl">
              From fragmented effort <br/><span className="italic">to institutional coherence.</span>
            </h2>
          </div>
          <div className="text-sm text-navy/60 max-w-sm">
            The move isn't technological — it's architectural. UNNATI rewires how training demand, supply and knowledge flow through the state.
          </div>
        </div>

        <div className="border border-navy/10 bg-white">
          <div className="grid grid-cols-12 border-b border-navy/10 bg-navy text-cream">
            <div className="col-span-1 p-4 font-mono-data text-xs tracking-[0.2em] uppercase opacity-60">#</div>
            <div className="col-span-5 p-4 font-mono-data text-xs tracking-[0.2em] uppercase opacity-80">Today</div>
            <div className="col-span-1 p-4 text-center opacity-40">→</div>
            <div className="col-span-5 p-4 font-mono-data text-xs tracking-[0.2em] uppercase" style={{color:'#E8B298'}}>With UNNATI</div>
          </div>
          {ROWS.map((r, i) => (
            <div key={i} data-testid={`shift-row-${i}`}
                 className={`grid grid-cols-12 border-b last:border-b-0 border-navy/10 ${i % 2 ? 'bg-cream/50' : 'bg-white'}`}>
              <div className="col-span-1 p-5 font-mono-data text-xs text-navy/40">{String(i+1).padStart(2,'0')}</div>
              <div className="col-span-5 p-5 text-navy/70 line-through decoration-1 decoration-terracotta/50">{r[0]}</div>
              <div className="col-span-1 p-5 text-center text-terracotta">→</div>
              <div className="col-span-5 p-5 font-serif-display text-lg text-navy">{r[1]}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
